<template>
    <el-table-column
        :prop="tableColum.prop"
        :label="tableColum.lable"
        :width="tableColum.width"
        :align="tableColum.align"
        :type="tableColum.type">
      <template slot-scope="scope" >
        <!--elSwitch-->
        <div v-if="tableColum.type == 'elSwitch'">
          <el-switch
            v-model="scope.row[`${tableColum.prop}`]"
            active-value="1"
            inactive-value="0"
            @change="handlerElSwitch(scope.row)"
            ></el-switch>
        </div>
        <!--urlCode二维码-->
        <div v-else-if="tableColum.type == 'urlCode'">
            <i class="isselectico iconfont icon-ico" @click="openUrlCode(scope.row)"></i>
        </div>
        <div v-else>
          {{ scope.row[`${tableColum.prop}`] | formatterColumn(tableColum) }}
        </div>
      </template>
    </el-table-column>
</template>

<script>
import moment from 'moment';
import $utils from '@/utils/commonUtils';
export default {
  data(){
    return{};
  },
  props: {
    //列表字段
    tableColum:{
      type:Object,
      default:function() {
        return {}
      }
    },
  },
  methods: {
    // el-switch 组件
    handlerElSwitch:function (row) {
      this.$emit('handlerElSwitch',row);
    },
    // 打开二维码组件
    openUrlCode:function (row) {
      this.$emit('openUrlCode',row);
    },
  },
  filters:{
    formatterColumn:function(val,column){
      let resultVal = val;
      if(column.type == 'date'){
        return resultVal?moment(resultVal).format("YYYY-MM-DD"):'';
      }else if(column.type == 'dateHHmm'){
        return resultVal?moment(resultVal).format("YYYY-MM-DD HH:mm"):'';
      }else if(column.type == 'HMS'){
        return resultVal?$utils.getHMS(resultVal):'';
      }else if(column.type == 'phoneSource'){
        return resultVal?$utils.getSourceCn(resultVal):'';
      }else{
        return resultVal;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.isselectico {
  color: #1890ff;
  cursor: pointer;
  font-size: 28px;
}
</style>
